import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const BrandsOverview = lazy(
  () =>
    import('./BrandsOverview.eager').then(mod => ({
      default: mod.BrandsOverview,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
